module.exports = __webpack_public_path__ + "img/plan04_text.ac685e4d.png";